export enum AccountTabLinks {
  profile = 'profile',
  billing = 'billing',
  users = 'users',
  settings = 'settings',
}
